import nxModule from 'nxModule';
import _ from 'lodash';

import templateUrl from './double-select-condition.template.html';
import './double-select-condition.style.less';

class DoubleSelectConditionComponent {
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    this.type = 'DOUBLE_SELECT';
    this.options2ForSelection = this.isConditionAlreadyDefined()
        ? this.options2.filter(o => o.definitionId === this.conditions[this.propertyDefinition.property].model.param1)
        : this.options2;

    this.$scope.$watchCollection('$ctrl.conditions', () => {
      if (!this.propertyDefinition) {
        return;
      }

      if (!this.isConditionAlreadyDefined()) {
        this.setDefaultValues();
      } else {
        this.fetchExistingValues();
      }
    });

    this.valueChanged = () => {
      this.options2ForSelection = this.options2.filter(o => o.definitionId === this.model.param1);
      this.saveValues();
    };
  }

  setDefaultValues() {
    this.model = {
      param1: null,
      param2: null
    };
  }

  fetchExistingValues() {
    this.model = this.conditions[this.propertyDefinition.property].model;
  }

  /**
   * Gets the only one allowed predicate for this type
   *
   * @returns {*}
   */
  getSupportedPredicate() {
    return this.propertyDefinition.supportedPredicates[0];
  }

  saveValues() {
    this.conditions[this.propertyDefinition.property] = {
      properties: [this.propertyDefinition.property],
      type: this.propertyDefinition.type,
      code: this.propertyDefinition.code,
      model: this.model,
      predicate: this.getSupportedPredicate(),
      options: []
    };
  }

  isConditionAlreadyDefined() {
    return _.has(this.conditions, this.propertyDefinition.property);
  }
}

nxModule.component('doubleSelectCondition', {
  templateUrl,
  bindings: {
    conditions: '=',
    options1: '=',
    options2: '=',
    propertyDefinition: '<'
  },
  controller: DoubleSelectConditionComponent
});
